import { observable } from 'mobx';

export const TAX_TYPE_ID = {
  TAXABLE_8_ID: 1,
  TAXABLE_10_ID: 2,
  HIKAZEI_ID: 3,
  FUKAZEI_ID: 4,
  MENZEI_ID: 5,
  NA_ID: 6,
  TAXED_REVENUE_10_ID: 7,
  // 既存IDを変えずに追加するため、表示順とID順は一致しない。
  HIKAZEI_TRANSIT_80_ID: 8,
  HIKAZEI_TRANSIT_70_ID: 14,
  HIKAZEI_TRANSIT_50_ID: 9,
  HIKAZEI_TRANSIT_30_ID: 15,
  TAXABLE_8_TRANSIT_80_ID: 10,
  TAXABLE_8_TRANSIT_70_ID: 16,
  TAXABLE_8_TRANSIT_50_ID: 11,
  TAXABLE_8_TRANSIT_30_ID: 17,
  TAXABLE_10_TRANSIT_80_ID: 12,
  TAXABLE_10_TRANSIT_70_ID: 18,
  TAXABLE_10_TRANSIT_50_ID: 13,
  TAXABLE_10_TRANSIT_30_ID: 19
} as const;

export type TaxTypeArgs = {
  id: number;
  name: string;
  tax_ratio: number;
};

class TaxType {
  @observable id: number;
  @observable name: string;
  @observable taxRatio: number;

  constructor(args: TaxTypeArgs) {
    this.id = args.id;
    this.name = args.name;
    this.taxRatio = args.tax_ratio;
  }
}

export default TaxType;
